import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initFacebookPixel } from './src/utils/FacebookPixel';
// Initialize Facebook Pixel as early as possible - before app mounts
console.log('🔍 Initializing Facebook Pixel before app mount');
initFacebookPixel().then(success => {
  console.log('Facebook Pixel early initialization:', success ? '✅ Success' : '❌ Failed');
  // Render the app after initialization attempt
  render(<App data-id="element-549" />, document.getElementById('root'));
});